var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_196_1",
    "data-name": "Component 196 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7680",
    "data-name": "Rectangle 7680",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16370",
    "data-name": "Path 16370",
    d: "M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2",
    fill: "none",
    stroke: "#810155",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1578",
    "data-name": "Ellipse 1578",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(8 3)",
    fill: "none",
    stroke: "#810155",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8f8116957b73bbb63b248c114ab23a6d.svg";
export { ForwardRef as ReactComponent };